import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { IconRightDecorator } from '../../../../components/Icon/IconRightDecorator';
import { Calendar } from '../../../../components/Icon';
import DatePicker from 'react-datepicker';
import cn from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styled from 'styled-components';
import { setNewInvoiceValue } from '../../actions';
import { selectNewInvoice, selectNewInvoiceValue } from '../../selectors';
import { Checkbox } from '../../../../components/Checkbox';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Loader } from '../../../../components/Loader';
import { Row, Cell } from '../../../../components/List';
import { VehicleCreateFieldCompanyUser } from '../../../Vehicles/pages/create/FieldCompanyUser';
import { selectConfig } from '../../../Api/selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { VBox } from '../../../../components/Box';
import { RegplateLabel } from '../../../Vehicles/components/RegplateLabel';
import styles from './FieldsVehicle.module.css';
import {Modal, ModalControls} from "../../../../components/Modal";
import Button from "../../../../containers/App/Components/Button/Button";

dayjs.extend(customParseFormat);

const STATE = {
  value: '',
};

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleInvoiceFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (!this.props.value || this.props.values?.id != this.props.match.params?.id) {
      this.props.vehicle && this.props.setValue(this.props.vehicle[this.props.type], this.props.type);
    }
  }

  componentDidUpdate(prevProps, prevState) {}

  isCheckbox() {
    return ['new_from_factory', 'import'].indexOf(this.props.type) > -1;
  }

  isDate() {
    return ['date_first_allowance'].indexOf(this.props.type) > -1;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return (
          <Row key={this.props.type}>
            {this.renderFirstDateAllowanceWarningNotification()}
            <Cell>{this.formFieldLabel()}</Cell>
            <Cell>
              <FormField>{children}</FormField>
            </Cell>
          </Row>
        );
    }
  }

  formFieldLabel() {
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  renderFirstDateAllowanceWarningNotification() {
    if (!this.state.showFirstDateAllowanceWarningNotification) return '';

    return (
      <Modal mediumWide onClose={() => this.setState({ showFirstDateAllowanceWarningNotification: false })}>
        <strong>{this.lbl('vehicle.property.date_first_allowance_confirmation_msg')}</strong>
        <ModalControls>
          <Button
            style={{ marginRight: '5px' }}
            small
            onClick={() => this.setState({ showFirstDateAllowanceWarningNotification: false }, () => {
              let d = dayjs(this.state.date).format('DD-MM-YYYY');
              this.props.setValue(d);
              this._t = this.timeout(this.props.calculateFinAmounts, 100, this._t);
            })}
          >
            {this.lbl('yes')}
          </Button>
          <Button small onClick={() => this.setState({ showFirstDateAllowanceWarningNotification: false })}>
            {this.lbl('cancel')}
          </Button>
        </ModalControls>
      </Modal>
    );
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;
    let selected = this.props.value && this.props.value !== 'null' && dayjs(this.props.value, format);
    const isCommercialVehicle = this.props.values.vehiclePurpose === 'commercial';

    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let dateFormat = this.props.type === 'date_first_allowance' ? 'DD-MM-YYYY' : 'YYYY-MM-DD hh:mm:ss';
            let d = dayjs(date).format(dateFormat);
            if (
              this.props.type === 'date_first_allowance' &&
              dayjs(date).year() < 2025 &&
              isCommercialVehicle &&
              !this.props.values.incoming_invoice_finalized
            ) {
              this.setState({ showFirstDateAllowanceWarningNotification: true, date })
            } else {
              this.props.setValue(d);
              this._t = this.timeout(this.props.calculateFinAmounts, 100, this._t);
            }
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  get requireMessage() {
    return this.props.isRequire?.includes(this.props.type);
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <>{this.wrap(this.renderField())}</>;
  }

  renderField() {
    if (this.isCheckbox()) {
      return (
        <Checkbox
          checked={this.props.value == '1' && this.props.value !== false}
          onChange={() => {
            let value;
            if (this.props.value === true || this.props.value == '1') {
              value = '0';
            }
            if (this.props.value === '0' || this.props.value === false) {
              value = '1';
            }

            if (this.props.type === 'import') {
              this.props.setValue(0, 'tempMargePrice');
            }
            return this.props.setValue(value);
          }}
        ></Checkbox>
      );
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    switch (this.props.type) {
      case 'regplate':
        return (
          <VBox>
            <input
              className="form-control"
              name="regplate"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            <RegplateLabel regplate={this.props.value?.length >= 3 ? this.props.value : 'nummer'} height="36" />
          </VBox>
        );
      case 'vin':
        return (
          <input
            className="form-control"
            name="vin"
            value={this.props.value || ''}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'mileage':
        return (
          <input
            className="form-control"
            name="mileage"
            value={this.props.value || ''}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'buying_contact':
        return (
          <>
            <VehicleCreateFieldCompanyUser
              selectedCreditorId={this.props.value}
              companyId={this.props.vehicle?.buyingCompany?.id}
              key={`${this.props.type}-${this.props.vehicles?.buyingCompany?.id}`}
              type={this.props.type}
              onChange={value => this.props.setValue(value)}
            />
            {this.requireMessage ? <RequireMark>*</RequireMark> : null}
          </>
        );
    }
  }
}

VehicleInvoiceFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectNewInvoiceValue(ownProps.type),
    values: selectNewInvoice(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleInvoiceField = compose(withConnect, withRouter)(VehicleInvoiceFieldComp);
